var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { FiPlus } from "react-icons/fi";
import useAuth from "../../../hooks/useAuth";
import api from "../../../services/api";
import { Alert, Table } from 'template/lib';
import { TiDeleteOutline } from "react-icons/ti";
import styles from './styles.module.scss';
import ModalAddLibrarie from '../../Modals/ModalAddLibrarie';
import ModalRemoveLibrarie from '../../Modals/ModalRemoveLibrarie';
var Libraries = function (props) {
    var _a;
    var _b = useState(1), page = _b[0], setPage = _b[1];
    var _c = useState(0), totalPages = _c[0], setTotalPages = _c[1];
    var _d = useState([]), items = _d[0], setItems = _d[1];
    var _e = useState(false), refresh = _e[0], setRefresh = _e[1];
    var _f = useState(true), loading = _f[0], setLoading = _f[1];
    var _g = useState(false), removeLibraries = _g[0], setRemoveLibraries = _g[1];
    var _h = useState(false), addLibraries = _h[0], setAddLibraries = _h[1];
    var _j = useState(false), alertOpen = _j[0], setAlertOpen = _j[1];
    var _k = useState(''), message = _k[0], setMessage = _k[1];
    var _l = useState(), id = _l[0], setId = _l[1];
    var login = useAuth().login;
    var config = {
        headers: { Authorization: "Bearer " + (login === null || login === void 0 ? void 0 : login.token) }
    };
    useEffect(function () {
        reload();
        if (refresh === true) {
            setRefresh(false);
        }
    }, [props.companyId, refresh]);
    var remove = function (id) {
        setId(id);
        setRemoveLibraries(true);
    };
    var addlibrarie = function () {
        setAddLibraries(true);
    };
    var lineBtnsWithoutAssignTo = [];
    var menuBtn = [];
    if ((login === null || login === void 0 ? void 0 : login.role) === 'Administrator') {
        menuBtn.push({
            icon: _jsx(FiPlus, { size: 16 }, void 0),
            id: 1,
            title: 'Nova Biblioteca',
            fn: function () { return addlibrarie(); }
        });
        lineBtnsWithoutAssignTo.push({
            name: "Remover",
            icon: _jsx(TiDeleteOutline, { size: 18, style: { color: 'red' } }, void 0),
            fn: function (id) { return remove(id); },
        });
    }
    var handleCloseModalAddLibrarie = function () {
        setAddLibraries(false);
    };
    var handleCloseModalRemoveLibrarie = function () {
        setRemoveLibraries(false);
    };
    var reload = function () {
        setLoading(true);
        api.get("/companies/" + props.companyId + "/libraries", config)
            .then(function (response) {
            var formattedData = response.data.map(function (lib) { return (__assign(__assign({}, lib), { principal: lib.principal ? "✅" : "" })); });
            setItems(formattedData);
        })
            .catch(function (err) { return console.error("Erro ao carregar bibliotecas:", err); })
            .finally(function () { return setLoading(false); });
    };
    useEffect(function () {
        setInterval(function () {
            setAlertOpen(false);
        }, 15000);
    }, [alertOpen]);
    return (_jsxs("div", __assign({ className: styles.container }, { children: [_jsx(Table, { page: page, setPage: setPage, data: items, totalPAges: totalPages, headerButtons: menuBtn, refresh: setRefresh, loading: loading, title: 'Bibliotecas', lineButton: lineBtnsWithoutAssignTo, columns: [
                    { label: 'Principal', key: 'principal', width: "90px", center: true },
                    { label: 'Empresa Proprietária', key: 'library' },
                    { label: 'Biblioteca', key: 'id', eventClick: (_a = lineBtnsWithoutAssignTo[0]) === null || _a === void 0 ? void 0 : _a.fn },
                    { label: 'Detalhes', key: 'details' },
                ] }, void 0), _jsx(ModalAddLibrarie, { handleOpenModalAddLibrarie: addLibraries, idItem: props.companyId, handleCloseModalAddLibrarie: handleCloseModalAddLibrarie, reload: reload, setAlertOpen: setAlertOpen, setMessage: setMessage }, void 0), _jsx(ModalRemoveLibrarie, { handleOpenModalRemoveLibrarie: removeLibraries, handleCloseModalRemoveLibrarie: handleCloseModalRemoveLibrarie, idItem: props.companyId, id: id, reload: reload }, void 0), alertOpen &&
                _jsx("div", __assign({ style: {
                        position: 'fixed',
                        top: '80px',
                        right: 0
                    } }, { children: _jsx(Alert, __assign({ info: false }, { children: message }), void 0) }), void 0)] }), void 0));
};
export default Libraries;
